// extracted by mini-css-extract-plugin
module.exports = {"alignTextAndLogo":"UpdateCardDetails_alignTextAndLogo__2Gqqk"};